<template>
  <div>
    <el-row>
      <el-button round @click="submitTransFloor()">轉換樓層</el-button>
      <el-table
        :data="roomList"
        style="width: 100%;margin-bottom: 20px;"
        row-key="_id"
        border
        default-expand-all
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
        <el-table-column
          prop="floor"
          label="樓層"
          sortable
          width="180">
        </el-table-column>
        <el-table-column
          prop="description"
          label="名稱"
          sortable
          width="180">
        </el-table-column>
        <el-table-column
          prop="name_eng"
          label="英文">
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
  import beaconJson from "../transData/ibeacon"
  import roomJSON from "../transData/rooms"
  import { createFloor, createRoom } from "../api/floor";

  export default {
    name: "TransferView",
    data() {
      return {
        beaconList: [],
        roomList: []
      }
    },
    mounted() {
      this.transRoomData();
    },
    methods: {
      transRoomData() {
        this.roomList = [];
        const floors = ['1F', '2F', '3F', 'B1'];
        for (const i in floors) {
          const floor = floors[i];
          const floorData = {
            _id: i,
            description: floor,
            name_eng: floor,
            floor: floor,
          };
          const filterFloor = roomJSON.filter(x => x['floor'] === floor);
          floorData.children = filterFloor;
          this.roomList.push(floorData);
        }
        console.log(this.roomList);
      },
      submitTransFloor: async function () {
        try {
          for (const i in this.roomList) {
            const floor = {
              name: this.roomList[i]['description'],
              name_eng: this.roomList[i]['name_eng']
            };
            const newFloor = await createFloor(floor);
            const children = this.roomList[i]['children'];
            for (const rIndex in children) {
              const room = {
                name: children[rIndex]['description'],
                name_eng: children[rIndex]['name_eng'],
                floor_id: newFloor.data.floor_id
              };
              await createRoom(room);
            }
          }
          return Promise.resolve(true);
        } catch (e) {
          return Promise.reject(e);
        }
      },
      transBeaconData() {
        this.beaconList = beaconJson;
      },
      submitTransBeaconData: async function() {
        try {
          for (const i in this.beaconList) {
            const beacon = {
              beacon_id: this.beaconList[i]['_id'],
              title: this.beaconList[i]['name'],
              uuid: this.beaconList[i]['uuid'],
              rssi: this.beaconList[i]['rssi'],
              type: parseInt(this.beaconList[i]['type'])
            };
            await createBeacon(beacon);
          }
          return Promise.resolve(true);
        } catch (e) {
          return Promise.reject(e)
        }
      },
    }
  }
</script>

<style scoped>

</style>
